var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: { transition: "scroll-y-transition", "offset-y": "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b({ attrs: { block: "" } }, "v-btn", attrs, false),
                  on
                ),
                [
                  _c("v-icon", { staticClass: "pr-1" }, [_vm._v(" mdi-web ")]),
                  _c("span", [_vm._v(_vm._s(_vm.$i18n.locale.toUpperCase()))]),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "v-list",
        _vm._l(_vm.$options.locales, function (localeItem) {
          return _c(
            "v-list-item",
            {
              key: localeItem.value,
              staticClass: "justify-center",
              on: {
                click: function ($event) {
                  return _vm.chooseLocaleHanlder(localeItem.value)
                },
              },
            },
            [_vm._v(" " + _vm._s(localeItem.title) + " ")]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }